import { App } from 'vue';
import { createPinia, Pinia } from 'pinia';

import Router from '@constant/router';

/**
 * 应用
 */
export default class Application {
  public static Main: App = null; // Vue
  public static readonly Pinia: Pinia = createPinia(); // 菠萝
  public static readonly Router: typeof Router = Router; // 路由
}